import {
  SET_STRUC_BULK_COPY_MODEL_IDS,
  STRUC_BULK_COPY_START,
  STRUC_BULK_COPY_SUCCESS,
  STRUC_BULK_COPY_FAIL,
  STRUC_BULK_COPY_RESET
} from './StructureBulkCopyActions';

export const initialState = {
  modelIds: [],
  bulkCopyFail: false,
  bulkCopyLoading: false,
  bulkCopySuccess: false,
  gridStore: {}
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_STRUC_BULK_COPY_MODEL_IDS:
      return {
        ...state,
        modelIds: action.modelIds,
        gridStore: action.gridStore
      };
    case STRUC_BULK_COPY_START:
      return {
        ...state,
        bulkCopyLoading: true,
        bulkCopyFail: false,
        bulkCopySuccess: false
      };
    case STRUC_BULK_COPY_SUCCESS:
      return {
        ...state,
        bulkCopyLoading: false,
        bulkCopyFail: false,
        bulkCopySuccess: true
      };
    case STRUC_BULK_COPY_FAIL:
      return {
        ...state,
        bulkCopyFail: true,
        bulkCopyLoading: false,
        bulkCopySuccess: false
      };
    case STRUC_BULK_COPY_RESET:
      if (action.resetAll) return { ...initialState };
      return { ...initialState, gridStore: state.gridStore, modelIds: state.modelIds };
    default: {
      return state;
    }
  }
}
